// removed by extract-text-webpack-plugin
module.exports = {"circle":"Image__circle___1yacp","interactionDisabled":"Image__interactionDisabled___1IUvB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/Image.css
// module id = 938
// module chunks = 4